"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _BuyForPointsButton = require("./BuyForPointsButton");
Object.keys(_BuyForPointsButton).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _BuyForPointsButton[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _BuyForPointsButton[key];
    }
  });
});
var _DialogContent = require("./DialogContent");
Object.keys(_DialogContent).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _DialogContent[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _DialogContent[key];
    }
  });
});
var _DialogHeader = require("./DialogHeader");
Object.keys(_DialogHeader).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _DialogHeader[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _DialogHeader[key];
    }
  });
});
var _FormattedMessage = require("./FormattedMessage");
Object.keys(_FormattedMessage).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _FormattedMessage[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _FormattedMessage[key];
    }
  });
});
var _LoyaltyDialog = require("./LoyaltyDialog");
Object.keys(_LoyaltyDialog).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _LoyaltyDialog[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _LoyaltyDialog[key];
    }
  });
});
